import React from "react";

import jllLogo from "images/JllLogo.png";

import { Container, LogoImg, AppTitle } from "./styles";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

const Logo = () => {
  //TODO: move navigation to Header component after refining
  const selectedClient = useSelector((state) => state.clients.selectedClient);
  const history = useHistory();

  const gotToHome = () => {
    history.push("/");
  };
  return (
    <Container onClick={gotToHome}>
      <LogoImg src={jllLogo} height="24" width="54.1" alt="JLL Logo" />

      <div className="center-flex">
        <AppTitle>{"TM Tracker"}</AppTitle>
      </div>
    </Container>
  );
};

export default Logo;
